import React, { useEffect } from 'react';
import styled from 'styled-components';
import Loading from 'react-loading';
import { Button } from 'rbx';

import { Table } from '../../../components/elements';
import useIntersectionObserver from '../../../utils/useIntersectionObserver';

const Center1 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LinkButton = props => (
  <Button {...props} className={`${props.className} link-button`} />
);

const OrderReportsTable = ({ orderReportsData, loading, loadMoreData }) => {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.5,
  });

  const [isCopied, setIsCopied] = React.useState(null);

  useEffect(() => {
    if (isIntersecting) {
      loadMoreData();
    }
  }, [isIntersecting]);

  const copyLink = (text, id) => {
    navigator.clipboard.writeText(text).then(
      // eslint-disable-next-line prefer-arrow-callback
      () => {
        setIsCopied(id);

        setTimeout(() => {
          setIsCopied(null);
        }, 5000);
      },
      // eslint-disable-next-line prefer-arrow-callback
      err => {
        console.error('Async: Could not copy text: ', err);
      },
    );
  };

  return (
    <>
      <div style={{ position: 'relative', padding: '10px' }}>
        <Table id="transactions-orders-table">
          <thead>
            <tr>
              {[
                'Id',
                'Menu Order Id',
                'User Id',
                'Email',
                'Order Reference',
                'Reason',
                'Action',
              ].map(headerCellValue => (
                <th key={headerCellValue} style={{ fontWeight: 700 }}>
                  <div>
                    <span>{headerCellValue}</span>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          {(orderReportsData ?? []).length !== 0 && (
            <tbody>
              {orderReportsData.map(ttData => (
                <tr
                  style={{ fontWeight: 600, cursor: 'pointer' }}
                  key={ttData.abandoned_order_id}
                >
                  <td style={{ color: '#00AEEF', whiteSpace: 'nowrap' }}>
                    {ttData.abandoned_order_id}
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>{ttData.order_id}</td>
                  <td style={{ color: '#00AEEF', whiteSpace: 'nowrap' }}>
                    {ttData.user_id}
                  </td>
                  <td>{ttData.email}</td>
                  <td>{ttData.order_reference}</td>
                  <td>{ttData.reason}</td>
                  <td>
                    <LinkButton
                      type="button"
                      onClick={e => {
                        e.stopPropagation();
                        copyLink(
                          JSON.stringify(ttData),
                          ttData.abandoned_order_id,
                        );
                      }}
                    >
                      {isCopied === ttData.abandoned_order_id
                        ? 'Copied'
                        : 'Copy Row'}
                    </LinkButton>
                  </td>
                </tr>
              ))}
              <div
                ref={ref}
                className="load-more"
                style={{ marginBottom: '2rem' }}
              />
            </tbody>
          )}
        </Table>
        {loading && (
          <Center1>
            <Loading type="spin" color="#363636" width="60px" height="60px" />
          </Center1>
        )}
      </div>
    </>
  );
};

export default OrderReportsTable;
